import { TicketRepository } from '../repositories/TicketRepository'

export function OperatorsListCase(ticketRepository: TicketRepository) {
  return async function () {
    return await ticketRepository.operationalList()
  }
}
